const getStoreLocale = () => {
  return localStorage && localStorage.geoLocale && JSON.parse(localStorage.geoLocale) && JSON.parse(localStorage.geoLocale).location;
};

const getStoreCurrencySymbol = () => {
  return localStorage && localStorage.geoLocale && JSON.parse(localStorage.geoLocale) && JSON.parse(localStorage.geoLocale).currencySymbol;
};

const getStoreCurrency = () => {
  return localStorage && localStorage.geoLocale && JSON.parse(localStorage.geoLocale) && JSON.parse(localStorage.geoLocale).currency;
};

const getActiveCurrency = () => {
  return window.Shopify?.currency?.active || 'USD';
};

const getStoreId = (locale) => {
  const storeIds = {
    'en-US': '1KuGV014z3fk9JILM7MrQG',
    'en-CA': '1KuGV014z3fk9JILM7MrQG',
    'en-GB': '39mROtdgVvAuHVbVYtts8u',
    'en-AU': '6Pzhak2CIJuXt3BMLfS8b0',
    'de-DE': '3r6AfrV2rdfjFOT6IgUI9p',
  };
  return storeIds[locale] || storeIds['en-US'];
};

export {
  getStoreLocale,
  getStoreCurrencySymbol,
  getStoreCurrency,
  getActiveCurrency,
  getStoreId,
};
